import React from 'react';
import { useGetCompaniesQuery } from '../../Companies/Service/companiesApi';
import type { Company } from '../../Companies/Types/companyTypes';
import {
  mapCompanyToBookingExpenseInvoiceLookup,
  type BookingExpenseInvoiceCompanyLookup,
} from './bookingExpenseInvoiceCompaniesLookupMapper';

type CompaniesQueryOptions = Parameters<typeof useGetCompaniesQuery>[1];
type CompaniesQueryResult = ReturnType<typeof useGetCompaniesQuery>;

type BookingExpenseInvoiceCompaniesLookupQueryResult = Pick<
  CompaniesQueryResult,
  'isLoading' | 'isFetching' | 'isError' | 'error' | 'refetch'
> & {
  data: BookingExpenseInvoiceCompanyLookup[];
};

export const useGetBookingExpenseInvoiceCompaniesLookupQuery = (
  options?: CompaniesQueryOptions
): BookingExpenseInvoiceCompaniesLookupQueryResult => {
  const queryResult = useGetCompaniesQuery(undefined, options);

  const data = React.useMemo(
    () =>
      (queryResult.data ?? [])
        .map((company: Company) => mapCompanyToBookingExpenseInvoiceLookup(company))
        .filter(
          (
            company: BookingExpenseInvoiceCompanyLookup | undefined
          ): company is BookingExpenseInvoiceCompanyLookup => Boolean(company)
        ),
    [queryResult.data]
  );

  return {
    data,
    isLoading: queryResult.isLoading,
    isFetching: queryResult.isFetching,
    isError: queryResult.isError,
    error: queryResult.error,
    refetch: queryResult.refetch,
  };
};

